/* globals window alert */
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';

import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import DeleteIcon from '@material-ui/icons/Delete';
import CopyIcon from '@material-ui/icons/FileCopy';
import EditIcon from '@material-ui/icons/Edit';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import MapIcon from '@material-ui/icons/Map';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { compareStrings, roundToTwoDecimals } from '../helper';
import { ExpandServices } from '../tabs/scheduled_work/ExpandServices';
import { apiDelete, apiGet, apiPut } from '../brainApi';

class DetailDialog extends Component {
  static prettyPrint(string) {
    const capitalized = string.charAt(0).toUpperCase() + string.slice(1);
    return capitalized.replace('_', ' ');
  }

  constructor(props) {
    super(props);
    const { event, allClientLocations } = this.props;
    this.state = {
      editingScheduleInstanceId: null,
      limitTotalHoursInput: -1,
      limitTotalDrivingHoursInput: -1,
      limitScheduledWorksInput: -1,
      clientLocationIds: event.scheduleInstance.client_locations.map(
        (cl) => cl.client_location_id,
      ),
      offeredServiceTypes: event.scheduleInstance.offered_service_types,
      isDemandBased: event.scheduleInstance.is_demand_based,
      scheduledWorkIDsWithExpandedServiceRows: new Set(),
    };

    this.sortedClientLocations = Object.values(allClientLocations);
    this.sortedClientLocations.sort((a, b) =>
      a.short_name > b.short_name ? 1 : -1,
    );
  }

  static getServiceTypes(offeredServiceTypes) {
    return offeredServiceTypes.map((string) =>
      DetailDialog.prettyPrint(string),
    );
  }

  getTableRows = (scheduleInstance) => {
    const {
      limit_total_hours: limitTotalHours,
      limit_total_driving_hours: limitTotalDrivingHours,
      limit_scheduled_works: limitScheduledWorks,
      client_locations: clientLocations,
      stats,
      schedule_instance_id: scheduleInstanceId,
    } = scheduleInstance;
    const { offeredServiceTypes } = this.state;
    const numberPotentialCustomers = clientLocations.reduce(
      (a, b) => a + b.number_potential_customers,
      0,
    );
    const {
      num_bookings: numBookings,
      num_services: numServices,
      booked_hours: bookedHours,
      booked_transit_hours: bookedTransitHours,
      num_bookings_by_cl: numBookingsByCl,
      num_services_by_cl: numServicesByCl,
    } = stats;

    const rows = [];
    const totals = {
      id: scheduleInstanceId,
      serviceTypes: DetailDialog.getServiceTypes(offeredServiceTypes),
      limitTotalHours,
      numberPotentialCustomers,
      numBookings,
      numServices,
      bookedHours,
      bookedTransitHours,
      limitTotalDrivingHours,
      limitScheduledWorks,
    };

    // TODO: figure out a better way to display locations with no bookings
    //  right now, we only display unbooked locations if there are less
    //  than 5 locations on the SI
    clientLocations.map((cl) => {
      if (numBookingsByCl[cl.id] > 0 || clientLocations.length < 100) {
        rows.push({
          clientLocationName: cl.short_name,
          numberPotentialCustomers: cl.number_potential_customers,
          numBookings: numBookingsByCl[cl.id],
          numServices: numServicesByCl[cl.id],
        });
      }
      return cl;
    });
    return { totals, rows };
  };

  setClientLocation = (clientLocationIds) => {
    this.setState({ clientLocationIds });
  };

  setOfferedServiceTypes = (offeredServiceTypes) => {
    this.setState({ offeredServiceTypes });
  };

  clientLocationSelectionRenderer = (values) => {
    const { allClientLocations } = this.props;
    switch (values.length) {
      case 0:
        return 'Client Locations';
      case 1:
        return allClientLocations[values[0]].long_name;
      default:
        return `${values.length} locations selected`;
    }
  };

  serviceTypeSelectionRenderer = (values) => {
    switch (values.length) {
      case 0:
        return 'Service Types';
      default:
        return `${values.map((value) => DetailDialog.prettyPrint(value))}`;
    }
  };

  toggleIsDemandBased = () => {
    this.setState((prevState) => ({
      isDemandBased: !prevState.isDemandBased,
    }));
  };

  editButton = ({
    id: scheduleInstanceId,
    limitTotalHours,
    limitScheduledWorks,
    limitTotalDrivingHours,
  }) => {
    return (
      <Button
        color="primary"
        onClick={() =>
          this.setState({
            editingScheduleInstanceId: scheduleInstanceId,
            limitTotalHoursInput: limitTotalHours,
            limitScheduledWorksInput: limitScheduledWorks,
            limitTotalDrivingHoursInput: limitTotalDrivingHours,
          })
        }
      >
        <EditIcon style={{ marginRight: '7px' }} />
        Edit
      </Button>
    );
  };

  deleteButton = (scheduleInstanceId) => {
    return (
      <Button
        color="primary"
        onClick={() => this.handleDelete(scheduleInstanceId)}
      >
        <DeleteIcon style={{ marginRight: '7px' }} />
        Delete
      </Button>
    );
  };

  copyButton = (scheduleInstanceId) => {
    const { handleCopy } = this.props;
    return (
      <Button color="primary" onClick={() => handleCopy(scheduleInstanceId)}>
        <CopyIcon style={{ marginRight: '7px' }} />
        Copy
      </Button>
    );
  };

  cancelButton = () => {
    return (
      <Button
        color="primary"
        onClick={() => this.setState({ editingScheduleInstanceId: null })}
      >
        <CancelIcon style={{ marginRight: '7px' }} />
        Cancel
      </Button>
    );
  };

  routeButton = (scheduleInstanceId) => {
    const { isDemandBased } = this.state;
    if (isDemandBased) {
      return (
        <Link
          to={`/route-visualizer/${scheduleInstanceId}`}
          style={{ textDecoration: 'none' }}
        >
          <Button color="primary">
            <MapIcon style={{ marginRight: '7px' }} />
            Route
          </Button>
        </Link>
      );
    }
    return (
      <Button
        color="primary"
        onClick={() => this.handleGmaps(scheduleInstanceId)}
      >
        <MapIcon style={{ marginRight: '7px' }} />
        Route
      </Button>
    );
  };

  submitButton = () => {
    return (
      <Button
        color="primary"
        variant="contained"
        onClick={this.handleEditLimits}
      >
        <CheckIcon style={{ marginRight: '7px' }} />
        Submit
      </Button>
    );
  };

  upsellInfo = (isUpsell, upsellStatus) => {
    if (!isUpsell) return 'Customer-created';
    return `Upsell: ${upsellStatus}`;
  };

  renderServicesTable = (scheduledWorkID, services) => {
    const { scheduledWorkIDsWithExpandedServiceRows } = this.state;
    if (scheduledWorkIDsWithExpandedServiceRows.has(scheduledWorkID)) {
      return (
        <TableRow>
          <TableCell colSpan={9}>{ExpandServices(services)}</TableCell>
        </TableRow>
      );
    }
    return null;
  };

  renderScheduledWorkExpandArrow = (scheduledWorkID) => {
    const { scheduledWorkIDsWithExpandedServiceRows } = this.state;
    if (scheduledWorkIDsWithExpandedServiceRows.has(scheduledWorkID)) {
      return (
        <ArrowDropDownIcon
          style={{ cursor: 'pointer' }}
          onClick={() => {
            scheduledWorkIDsWithExpandedServiceRows.delete(scheduledWorkID);
            this.setState({ scheduledWorkIDsWithExpandedServiceRows });
          }}
        />
      );
    }
    return (
      <ArrowRightIcon
        style={{ cursor: 'pointer' }}
        onClick={() => {
          scheduledWorkIDsWithExpandedServiceRows.add(scheduledWorkID);
          this.setState({ scheduledWorkIDsWithExpandedServiceRows });
        }}
      />
    );
  };

  renderBookings = (scheduleInstance) => {
    const { scheduledWorkIDsWithExpandedServiceRows } = this.state;
    const allScheduledWorks = scheduleInstance.scheduled_works;
    const flatScheduledWorks = [].concat(...allScheduledWorks);

    if (!flatScheduledWorks.length) {
      return <div />;
    }

    flatScheduledWorks.sort((a, b) => {
      return compareStrings(a.client_location_name, b.client_location_name);
    });

    return (
      <Table className="myTable">
        <TableHead>
          <TableRow>
            <TableCell>
              <Tooltip
                title={
                  scheduledWorkIDsWithExpandedServiceRows.size > 0
                    ? 'Collapse All'
                    : 'Expand All'
                }
                placement="top"
              >
                <Button
                  color="primary"
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    if (scheduledWorkIDsWithExpandedServiceRows.size > 0) {
                      this.setState({
                        scheduledWorkIDsWithExpandedServiceRows: new Set(),
                      });
                    } else {
                      flatScheduledWorks.forEach((sw) => {
                        scheduledWorkIDsWithExpandedServiceRows.add(
                          sw.scheduled_work_id,
                        );
                      });
                      this.setState({
                        scheduledWorkIDsWithExpandedServiceRows,
                      });
                    }
                  }}
                >
                  {scheduledWorkIDsWithExpandedServiceRows.size > 0 ? (
                    <UnfoldLessIcon />
                  ) : (
                    <UnfoldMoreIcon />
                  )}
                </Button>
              </Tooltip>
            </TableCell>
            <TableCell>Appointment</TableCell>
            <TableCell numeric>Service Hours</TableCell>
            <TableCell numeric>Number of Services</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Customer Location</TableCell>
            <TableCell>Created At</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {flatScheduledWorks.map((sw) => (
            <React.Fragment>
              <TableRow
                key={sw.scheduled_work_id}
                className={`scheduledWorkRow-${sw.status}`}
                hover
              >
                <TableCell>
                  {this.renderScheduledWorkExpandArrow(sw.scheduled_work_id)}
                </TableCell>
                <TableCell component="th" scope="row">
                  <a
                    href={`/#/scheduled-work/${sw.scheduled_work_id}/show`}
                  >
                    {sw.scheduled_work_id}
                  </a>
                </TableCell>
                <TableCell numeric>
                  {roundToTwoDecimals(sw.service_hours)}
                </TableCell>
                <TableCell numeric>{sw.num_services}</TableCell>
                <TableCell component="th" scope="row">
                  {sw.customer_email}
                </TableCell>
                <TableCell component="th" scope="row">
                  {sw.customer_first_name} {sw.customer_last_name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {sw.client_location_name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {sw.created_at}
                </TableCell>
                <TableCell component="th" scope="row">
                  {sw.status}
                </TableCell>
              </TableRow>
              {this.renderServicesTable(sw.scheduled_work_id, sw.services)}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    );
  };

  handleDelete = (scheduleInstanceId) => {
    const { updateCalendar, onClose } = this.props;
    if (window.confirm('Are you sure you want to DELETE this booking date?')) {
      return apiDelete(`/schedule/${scheduleInstanceId}`).then((json) => {
        if (json.Status === 'Failure') {
          alert(`Error:\n\n${json.Message}`);
        } else {
          updateCalendar(json);
          onClose();
        }
      });
    }
    return false;
  };

  handleGmaps = (scheduleInstanceId) => {
    return apiGet(`/get-schedule-google-maps-link/${scheduleInstanceId}`).then(
      (json) => {
        window.open(json.url);
      },
    );
  };

  handleEditLimits = () => {
    const {
      limitTotalHoursInput,
      limitScheduledWorksInput,
      limitTotalDrivingHoursInput,
      clientLocationIds,
      offeredServiceTypes,
      isDemandBased,
    } = this.state;

    const totalServiceHours = parseFloat(limitTotalHoursInput);
    const totalDrivingHours = parseFloat(limitTotalDrivingHoursInput);
    const totalNumServices = parseInt(limitScheduledWorksInput, 10);
    if (!(totalServiceHours >= 0 && totalServiceHours <= 84)) {
      alert(
        `Invalid value for service hours: ${totalServiceHours}. Must be between 0 and 84.`,
      );
      return;
    }
    if (!(totalNumServices >= 0)) {
      alert(
        `Invalid value for service hours: ${totalNumServices}. Must be at least 0.`,
      );
      return;
    }
    this.handleEdit({
      limit_total_hours: totalServiceHours,
      client_location_ids: clientLocationIds,
      offered_service_types: offeredServiceTypes,
      is_demand_based: isDemandBased,
      limit_total_driving_hours: totalDrivingHours,
      limit_scheduled_works: totalNumServices,
    });
  };

  handleEdit = (updatedValues) => {
    const { editingScheduleInstanceId } = this.state;

    if (!editingScheduleInstanceId) {
      alert('Error');
      return;
    }

    apiPut(`/schedule/${editingScheduleInstanceId}`, updatedValues).then(
      (json) => {
        if (json.Status === 'Failure') {
          alert(`Error:\n\n${json.Message}`);
        } else {
          const { onClose, updateCalendar } = this.props;
          this.setState({ editingScheduleInstanceId: null });
          updateCalendar(json);
          onClose();
        }
      },
    );
  };

  renderTable = (event) => {
    const { start, serviceVehicle, scheduleInstance } = event;
    const {
      editingScheduleInstanceId,
      clientLocationIds,
      offeredServiceTypes,
      isDemandBased,
    } = this.state;
    const { allScheduleTypes } = this.props;
    const { totals, rows } = this.getTableRows(scheduleInstance);
    const dateString = moment(start).format('dddd, MMM Do');

    const editMode = editingScheduleInstanceId === totals.id;
    return (
      <Fragment>
        <Table className="myTable">
          <TableHead>
            <TableRow>
              <TableCell
                style={{ fontWeight: 'bold', fontSize: '120%', color: 'black' }}
              >
                {serviceVehicle.name}&nbsp;&nbsp;&nbsp;
                <br />
                {dateString}
              </TableCell>
              <TableCell>Service Types</TableCell>
              {clientLocationIds.length > 0 && (
                <TableCell numeric>Total Potential Customers</TableCell>
              )}
              <TableCell numeric>Working Hours Limit</TableCell>
              <TableCell numeric>Booked Hours</TableCell>
              <TableCell numeric>Number of Bookings</TableCell>
              <TableCell numeric>Number of Services</TableCell>
              <TableCell numeric>Number of Services Limit</TableCell>
              <TableCell numeric>Booked Transit Hours</TableCell>
              <TableCell numeric>Transit Hours Limit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key={totals.id} hover selected>
              {!editMode && (
                <TableCell>
                  <div style={{ display: 'flex' }}>
                    {this.editButton(totals)}
                    {this.deleteButton(totals.id)}
                    {this.copyButton(scheduleInstance)}
                    {this.routeButton(scheduleInstance.schedule_instance_id)}
                  </div>
                </TableCell>
              )}
              {editMode && (
                <Fragment>
                  <TableCell>
                    <div style={{ display: 'flex' }}>
                      <Select
                        id="client-locations"
                        displayEmpty
                        multiple
                        value={clientLocationIds}
                        onChange={(e) => this.setClientLocation(e.target.value)}
                        fullWidth
                        renderValue={this.clientLocationSelectionRenderer}
                      >
                        {this.sortedClientLocations.map((location) => (
                          <MenuItem
                            key={location.client_location_id}
                            value={location.client_location_id}
                          >
                            {location.long_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex' }}>
                      <Select
                        id="service-types"
                        displayEmpty
                        multiple
                        value={offeredServiceTypes}
                        onChange={(e) =>
                          this.setOfferedServiceTypes(e.target.value)
                        }
                        fullWidth
                        renderValue={this.serviceTypeSelectionRenderer}
                      >
                        {allScheduleTypes.map((serviceType) => (
                          <MenuItem key={serviceType} value={serviceType}>
                            {DetailDialog.prettyPrint(serviceType)}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </TableCell>
                </Fragment>
              )}
              {!editMode && (
                <TableCell>{totals.serviceTypes.join(', ')}</TableCell>
              )}
              {clientLocationIds.length > 0 && (
                <TableCell numeric>{totals.numberPotentialCustomers}</TableCell>
              )}
              <TableCell numeric>
                {editMode ? (
                  <form onSubmit={this.handleEditLimits}>
                    <TextField
                      style={{ width: '100px' }}
                      defaultValue={totals.limitTotalHours}
                      onChange={(e) =>
                        this.setState({
                          limitTotalHoursInput: e.target.value,
                        })
                      }
                    />
                  </form>
                ) : (
                  totals.limitTotalHours
                )}
              </TableCell>
              <TableCell numeric>{totals.bookedHours || 0}</TableCell>
              <TableCell numeric>{totals.numBookings || 0}</TableCell>
              <TableCell numeric>{totals.numServices || 0}</TableCell>
              <TableCell numeric>
                {editMode ? (
                  <form onSubmit={this.handleEditLimits}>
                    <TextField
                      style={{ width: '100px' }}
                      defaultValue={totals.limitScheduledWorks}
                      onChange={(e) =>
                        this.setState({
                          limitScheduledWorksInput: e.target.value,
                        })
                      }
                    />
                  </form>
                ) : (
                  totals.limitScheduledWorks
                )}
              </TableCell>
              <TableCell numeric>{totals.bookedTransitHours || 0}</TableCell>
              <TableCell numeric>
                {editMode ? (
                  <form onSubmit={this.handleEditLimits}>
                    <TextField
                      style={{ width: '100px' }}
                      defaultValue={totals.limitTotalDrivingHours}
                      onChange={(e) =>
                        this.setState({
                          limitTotalDrivingHoursInput: e.target.value,
                        })
                      }
                    />
                  </form>
                ) : (
                  totals.limitTotalDrivingHours
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {editMode && (
          <Fragment>
            <FormControlLabel
              control={
                <Switch
                  label="Is Demand Based"
                  checked={isDemandBased}
                  onChange={this.toggleIsDemandBased}
                />
              }
              label="Demand-Based"
            />
          </Fragment>
        )}
        {clientLocationIds.length > 0 && (
          <Table className="myTable">
            <TableHead>
              <TableRow>
                <TableCell>Client Location</TableCell>
                <TableCell numeric>Number Potential Customers</TableCell>
                <TableCell numeric>Booked Hours</TableCell>
                <TableCell numeric>Number of Bookings</TableCell>
                <TableCell numeric>Number of Services</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.clientLocationName}
                  </TableCell>
                  <TableCell numeric>{row.numberPotentialCustomers}</TableCell>
                  <TableCell numeric>{row.bookedHours || 0}</TableCell>
                  <TableCell numeric>{row.numBookings || 0}</TableCell>
                  <TableCell numeric>{row.numServices || 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Fragment>
    );
  };

  render() {
    const { event, open, onClose } = this.props;
    const { editingScheduleInstanceId } = this.state;
    if (!event) {
      return <div />;
    }

    const { scheduleInstance } = event;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
        maxWidth={false}
      >
        <DialogContent>
          <div className="outerDetail">
            {this.renderTable(event)}
            <hr />
            {this.renderBookings(scheduleInstance)}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose(false)} color="primary">
            Close
          </Button>
          {editingScheduleInstanceId && this.submitButton()}
        </DialogActions>
      </Dialog>
    );
  }
}

export default DetailDialog;
